import { ArrowRight, Home, Building2, Factory, Sprout, Droplets, Lightbulb } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/landing/Reveal";
import { SOLUTIONS } from "@/data/content";
import { useQuote } from "@/context/QuoteContext";

const iconMap = { Home, Building2, Factory, Sprout, Droplets, Lightbulb };

const Solutions = () => {
  const { openQuote } = useQuote();

  return (
    <section id="solutions" className="py-24 md:py-32" data-testid="solutions-section">
      <div className="max-shell mx-auto px-4 md:px-8 lg:px-12">
        <Reveal className="flex justify-center text-center">
          <SectionHeading
            eyebrow="Our Solar Solutions"
            title="Solar Solutions For Every Energy Need"
            subtitle="From residential rooftops to industrial installations, we design systems around your actual energy requirements."
            className="mx-auto"
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SOLUTIONS.map((s, i) => {
            const Icon = iconMap[s.icon];
            return (
              <Reveal key={s.id} delay={(i % 3) * 0.08}>
                <article
                  className="group h-full rounded-3xl bg-white border border-slate-100 shadow-soft overflow-hidden transition-transform duration-300 hover:-translate-y-1.5 hover:shadow-lift border-b-2 border-b-transparent hover:border-b-brand-green"
                  data-testid={`solution-card-${s.id}`}
                >
                  <div className="relative h-52 overflow-hidden">
                    <img
                      src={s.image}
                      alt={`${s.title} — solar installation by Global Eco`}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <span className="absolute left-4 bottom-4 grid place-items-center h-11 w-11 rounded-full glass text-brand-green shadow-soft">
                      <Icon className="h-5 w-5" />
                    </span>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-brand-navy">{s.title}</h3>
                    <p className="mt-2 text-[15px] leading-relaxed text-slate-500">{s.desc}</p>
                    <button
                      onClick={() => openQuote(`solution-${s.id}`)}
                      data-testid={`solution-learn-${s.id}`}
                      className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-green group/btn"
                    >
                      Learn More
                      <ArrowRight className="h-4 w-4 group-hover/btn:translate-x-1 transition-transform" />
                    </button>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
